import React from "react";
import OperatorServiceTickets from "../../components/dashboard/OperatorServiceTickets";

const OperatorPlatformGRH = () => (
  <OperatorServiceTickets
    serviceCode="grh"
    title="Ressources humaines"
    lead="Les demandes liées au module ressources humaines de Gestion 360."
  />
);

export default OperatorPlatformGRH;
